import { Box, MenuItem, Select, Typography } from "@mui/material"
import { StyledFormControl } from "shared/styled/General"
import { StyledBox, StyledSortBox } from "./SortForm.styled"
import { useTranslation } from "react-i18next"

const SortForm = ({ onChange, setState, state }) => {
  const { t } = useTranslation("translation")

  return (
    <StyledBox mb={1}>
      <Box>
        <StyledFormControl size="small">
          <Select
            variant="outlined"
            labelId="sortby-label"
            id="sortby"
            value={state.sortby}
            onChange={(event) => {
              const value = event.target.value
              setState((s) => {
                return {
                  ...s,
                  sortby: value
                }
              })
              onChange({
                ...state,
                sortby: value
              })
            }}>
            <MenuItem value={0}>{t("global.latest_first", "Latest first")}</MenuItem>
            <MenuItem value={1}>{t("global.oldest_first", "Oldest first")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Box>
    </StyledBox>
  )
}

export default SortForm
